export default __webpack_public_path__ + "static/media/IconsWebsite_Videos.dbd494eb.svg";